// extracted by mini-css-extract-plugin
module.exports = {"ol":"static-module--ol--2Rqgi","p":"static-module--p--2mLCo"};